import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_jf",
  "use": "icon-home_jf-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"#1989FA\" stroke-width=\"2\" id=\"icon-home_jf\">\n  <rect x=\"6\" y=\"6\" width=\"32\" height=\"32\" rx=\"4\" />\n  <circle cx=\"14\" cy=\"16\" r=\"5\" fill=\"#1989FA\" stroke=\"none\" />\n  <line x1=\"22\" y1=\"16\" x2=\"34\" y2=\"16\" />\n  <line x1=\"22\" y1=\"24\" x2=\"34\" y2=\"24\" />\n  <line x1=\"22\" y1=\"32\" x2=\"34\" y2=\"32\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol